import { useTheme } from '../../context/ThemeContext';

/**
 * MytineriLogo - Theme-aware logo component
 */
export default function MytineriLogo({ className = "w-7 h-7" }) {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  const bgColor = isDark ? '#0F0F0F' : '#FFFFFF';
  const iconColor = isDark ? '#74A79B' : '#5D9085';
  const accentColor = isDark ? '#6D9D91' : '#68988D';
  
  return (
    <svg className={className} viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg">
      <rect width="192" height="192" fill={bgColor} />
      <path 
        fill={iconColor}
        d="M190,123c-0.8,0.4-1.6,0.7-3,0.7c-2.4-0.5-4.2-0.7-6-0.7c-56.9,0-113.8,0-170.7,0c-2.8,0-5.6-0.6-8.4-1
          c0-1.1,0-2.2,0-3.6c2.2-1.7,4.3-3.6,6.7-4.3c8.1-2.4,16.3-4.4,24.6-6.4c24.4-5.9,46.9-15.4,66.3-31.8
          c8-6.8,16.4-6.1,24.5,0.8c5.7,4.9,11.4,9.8,17.1,14.6c13,11.1,28.5,16.8,44.5,21.7c2.8,0.9,5.3,3,8.1,4.8
          c0,1.3,0,2.4,0,3.9c-0.4,0.8-0.6,1.1-0.7,1.4C192.1,122.4,191.6,123,190,123z"
      />
      <path 
        fill={accentColor}
        d="M2.1,122.4c2.7,0,5.5,0.6,8.4,0.6c56.9,0.1,113.8,0,170.7,0c1.8,0,3.6,0.2,6,0.6
          c-7.8,0.5-15.9,0.9-24,1.1c-51,0.2-102,0.3-153,0.3c-2.4,0-4.9-1.4-7.4-2.1C2.1,122.4,2.1,122.4,2.1,122.4z"
      />
    </svg>
  );
}
